module.exports = __webpack_public_path__ + "img/xperio-white.f07fa577.svg";